"use strict";

module.exports = [
    {
        pattern: /Chrome/i,
        name: "Chrome"
    },
    {
        pattern: /Chromium/i,
        name: "Chromium"
    },
    {
        pattern: /Firefox/i,
        name: "Firefox"
    },
    {
        pattern: /MSIE|Trident/i,
        name: "IE"
    },
    {
        pattern: /(Opera)|(OPR)/i,
        name: "Opera"
    },
    {
        pattern: /Safari/i,
        name: "Safari"
    }
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/@browser-detection/dist/lib/browser-names.js
// module id = 704
// module chunks = 0